import axios from './axios'
import mlAxios from './axios_ml.js'

export const rocketChatLogin = personId =>
  axios.get(`/rocket_chat/login/${personId}`)

export const getRocketChatRooms = data =>
  axios.get(`/rocket_chat/rooms?person_id=${data.person_id}&client_id=${data.client_id}`)

export const getRocketChatMessages = data =>
  axios.get(`/rocket_chat/messages?room_id=${data.roomId}&person_id=${data.personId}&isDm=${data.isDm}&count=${data.count}&ts=${data.ts}&next=${data.next}&inclusive=${data.inclusive}&viewer_id=${data.viewer_id}`)

export const getRocketChatMessageById = data =>
  axios.get(`/rocket_chat/message?person_id=${data.personId}&message_id=${data.messageId}`)

export const getRocketMessagesReceipt = data =>
  axios.get(`/rocket_chat/read_receipt?channels=${data.channels}&person_id=${data.personId}`)

export const getRocketChatThreads = data =>
  axios.get(`/rocket_chat/allThreads?room_id=${data.roomId}&person_id=${data.personId}`)

export const getRocketChatThreadMessages = data =>
  axios.get(`/rocket_chat/thread?thread_id=${data.threadId}&person_id=${data.personId}`)

export const getRocketChatPinnedMessages = data =>
  axios.get(`/rocket_chat/pinned_messages?room_id=${data.roomId}&person_id=${data.personId}`)

export const pinRocketChatMessage = data =>
  axios.post('/rocket_chat/pin_message', data)

export const deleteRocketChatMessage = data =>
  axios.delete(`/rocket_chat/delete_message?message_id=${data.msgId}&person_id=${data.personId}&room_id=${data.roomId}`)

export const editRocketChatMessage = data =>
  axios.put('/rocket_chat/edit_message', data)

export const getCommunityMembers = data =>
  axios.get('/rocket_chat/community_members')

export const createDM = data =>
  axios.post('/rocket_chat/create_dm', data)

export const searchMessage = data =>
  axios.get(`/rocket_chat/search_messages?room_id=${data.roomId}&person_id=${data.personId}&search_text=${data.searchText}`)

export const searchKnowledgeDB = data =>
  mlAxios.post('/api/ml/search', {content_type: 'all', question: data})

export const createChatbotFeedback = data =>
  axios.post('/chatbot_feedbacks', {
    message_id: data.message_id,
    query: data.query,
    bot_response: data.bot_response,
    feedback: data.feedback,
    role: data.role,
    person_id: data.person_id,
    room_id: data.room_id
  })
